import React from 'react';
import { Badge } from '@mantine/core';
import type { EntityRegistryEntry } from '../types';

export const photoConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'ContentType', 'Owner', 'OwnerType', 'SchoolYear', 'Size'],
    listColumns: () => [
        {
            key: 'contenttype',
            label: 'Content Type',
            sortable: true,
            render: (entity: any) => {
                const ct = (entity.ContentType || '').toString().trim();
                if (!ct) return '';
                return <Badge variant="outline" size="sm" color="blue">{ct}</Badge>;
            }
        },
        {
            key: 'owner',
            label: 'Owner',
            sortable: true,
            render: (entity: any) => {
                const owner = entity.Owner;
                if (!owner) return '';
                if (typeof owner === 'object') {
                    return owner.DisplayName || owner.displayName || owner.Id || '';
                }
                return String(owner);
            }
        },
        {
            key: 'schoolyear',
            label: 'School Year',
            sortable: true,
            render: (entity: any) => (entity.SchoolYear ?? '').toString()
        },
    ],
};
